import cn from "classnames";

export default function createThemedStyles(baseStyles, themeStyles) {
  if (!themeStyles) return baseStyles;

  const classNames = Object.keys(Object.assign({}, baseStyles, themeStyles));
  const mergedStyles = {};

  classNames.forEach((className) => {
    mergedStyles[className] = cn(baseStyles[className], themeStyles[className]);
  });

  return mergedStyles;
}
